import React from 'react';
export default function LinkToCollection(props) {
    return (React.createElement("a", { href: `/api/public/users/order/${props.orderId}/collection?key=${props.orderKey}` }, "Przejd\u017A do kolekcji ze zdj\u0119ciami"));
}
